import * as CONST from '../ActionTypes';

const initialState = {
  isSuccess: false,
  isFailure: false,
  errorMessage: '',
  ecShoppingGuide: {},
  ecShoppingGuideList: [],
};

function ecShoppingGuide(state = initialState, action) {
  switch (action.type) {
    // -----------------
    // EC情報一覧取得
    // -----------------
    case CONST.GET_EC_SHOPPING_GUIDE_LIST_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          ecShoppingGuideList: action.payload,
        },
      );
    case CONST.GET_EC_SHOPPING_GUIDE_LIST_FAILURE:
      return Object.assign(
        {},
        state,
        {
          isFailure: true,
          ecShoppingGuideList: {},
        },
      );
    // -----------------
    // 結果フラグクリア
    // -----------------
    case CONST.CLEAR_DELETE_EC_SHOPPING_GUIDE_RESULT_FLG:
      return Object.assign(
        {},
        state,
        {
          isSuccess: false,
          isFailure: false,
          errorMessage: '',
        },
      );
    default:
      return state;
  }
}

export default ecShoppingGuide;
